export default __webpack_public_path__ + "static/media/stories.ddc7397b.svg";